module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/text_field-3df136e7e0ea60dc6bcbf61d47e69746.svg";